import React, { useState, useEffect } from "react";
import LoginGuru from "./LoginGuru";
import {
	NavLink,
	BrowserRouter,
	Switch,
	Route,
	useLocation,
} from "react-router-dom";
import AppBar from "@material-ui/core/AppBar";
import ToolBar from "@material-ui/core/ToolBar";
import { makeStyles } from "@material-ui/core/styles";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import TableKuis1 from "./Kuis1/TableKuis1";
import TableKuis2 from "./Kuis2/TableKuis2";
import Pretest from "./Pretest/Pretest";
import "../Guru/Dashboardguru.css";
import MenuIcon from "@material-ui/icons/Menu";
import CancelIcon from "@material-ui/icons/Cancel";
// import bghome from "./home.png";
// import MediaQuery from "react-responsive";
import TableKuis3 from "./Kuis3/TableKuis3";
import TableEvaluasi from "./Evaluasi/TableEvaluasi";
import Home from "./Home/Home";


const useStyle = makeStyles((theme) => ({
	tittle: {
		flexGrow: 1,
		marginTop: "1rem",
		marginLeft: "15px",
	},
	navbar: {
		background: "rgba(75,178,115,0.9)",
	},
	imageProfil: {
		height: "40px",
		width: "40px",
		borderRadius: "50%",
	},
	closeicon: {
		color: "white",
		height: "30px",
		width: "30px",
	},
}));

const DashboardGuru = (props) => {
	const classes = useStyle();
	const [user, setUser] = useState("");
	const [sidebar, setSidebar] = useState(false);
	const location = useLocation();
	const showSidebar = () => {
		setSidebar(!sidebar);
	};
	const signOut = () => {
		localStorage.removeItem("user");
		setUser(null);
	};

	////autentikasi google
	const userState = () => {
		const data = localStorage.getItem("user");
		const userobject = data !== null ? JSON.parse(data) : null;
		setUser(userobject);
	};

	useEffect(() => {
		userState();
	}, []);

	return (
		<div>
			{user !== null ? (
				<div>
					<AppBar position="static" className={classes.navbar}>
						<ToolBar>
							<div className="navbar">
								<div className="nav-menu-icon" onClick={showSidebar}>
									<MenuIcon style={{ cursor: "pointer" }} />
								</div>
							</div>
							<div className={classes.tittle}>
								<div
									style={{
										width: "12%",
										display: "flex",
										justifyContent: "space-between",
									}}
								>
									<img
										style={{
											borderRadius: "70px",
											width: "40px",
											height: "40px",
										}}
										src={user.photo}
										alt="userphoto"
									/>
									<h6>
										<span>{user.username}</span>
									</h6>
								</div>
							</div>
							<button className="btn btn-success" onClick={() => signOut()}>
								<ExitToAppIcon />
							</button>
						</ToolBar>
					</AppBar>
					<div
						className={
							sidebar ? "sidebar-container active" : "sidebar-container"
						}
					>
						<ul className="sidebar-items">
							<li className="sidebar-toggle" onClick={showSidebar}>
								<div>
									<CancelIcon
										style={{ cursor: "pointer" }}
										className={classes.closeicon}
									/>
								</div>
							</li>
							<li className="sidebar-item" onClick={showSidebar}>
								<NavLink to="/guru/pretest">Tabel Pretest</NavLink>
							</li>
							<li className="sidebar-item" onClick={showSidebar}>
								<NavLink to="/guru/kuis1">Tabel Kuis 1</NavLink>
							</li>
							<li className="sidebar-item" onClick={showSidebar}>
								<NavLink to="/guru/kuis2">Tabel Kuis 2</NavLink>
							</li>
							<li className="sidebar-item" onClick={showSidebar}>
								<NavLink to="/guru/kuis3">Tabel Kuis 3</NavLink>
							</li>
							<li className="sidebar-item" onClick={showSidebar}>
								<NavLink to="/guru/evaluasi">Tabel Evaluasi</NavLink>
							</li>
						</ul>
					</div>
					<div className="container">
						<BrowserRouter>
							<Switch location={location} key={location.pathname}>

								<Route exact path="/guru">
									<Home />
								</Route>
								<Route exact path="/guru/pretest">
									<Pretest />
								</Route>
								<Route exact path="/guru/kuis1">
									<TableKuis1 />
								</Route>
								<Route exact path="/guru/kuis2">
									<TableKuis2 />
								</Route>
								<Route exact path="/guru/kuis3">
									<TableKuis3 />
								</Route>
								<Route exact path="/guru/evaluasi">
									<TableEvaluasi />
								</Route>
							</Switch>
						</BrowserRouter>
					</div>
					{/* <div className="container mt-4">
						<div className="text-center display-5">
							Selamat Datang Di Halaman Utama Guru
						</div>
						<div className="text-center blockquote">
							Silahkan Langsung Klik Menu Sidebar Agar Dapat Melihat Nilai Siswa
						</div>
						<MediaQuery minWidth={476} maxWidth={1824}>
							<div className="w-100">
								<img src={bghome} alt={bghome} />
							</div>
						</MediaQuery>
						<MediaQuery maxWidth={475}>
							<img src={bghome} alt={bghome} style={{height:'300px', width:'335px',marginLeft:'10px'}} />
						</MediaQuery>
					</div> */}
				</div>
			) : (
				<LoginGuru
					loggedIn={(user) => setUser(user)}
					signin={(user) => setUser(user)}
				/>
				//loggedIn={(user) => setUser(user)}
				// signin={(user) => setUser(user)}
			)}
		</div>
	);
};

export default DashboardGuru;
